import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCloudArrow = () => {
  return (
    <g>
      <path d="m14.1821 6.9551a4.7865 4.7865 0 0 0 .1328-1.1172 4.9125 4.9125 0 0 0 -4.9072-4.9072 4.8593 4.8593 0 0 0 -4.291 2.5449 2.898 2.898 0 0 0 -.4009-.0283 2.9707 2.9707 0 0 0 -2.9673 2.9677 2.8726 2.8726 0 0 0 .0532.5488 3.47 3.47 0 0 0 -1.7685 3.0313 3.506 3.506 0 0 0 3.5019 3.502h2.0137a.75.75 0 0 0 0-1.5h-2.0136a1.9941 1.9941 0 0 1 -.5869-3.9023.75.75 0 0 0 .4531-1.0448 1.4437 1.4437 0 0 1 -.1528-.6348 1.4767 1.4767 0 0 1 2.0088-1.36.7509.7509 0 0 0 .977-.4287 3.3992 3.3992 0 1 1 6.3325 2.4717.75.75 0 0 0 .478.9951 1.9837 1.9837 0 0 1 1.4219 1.9023 2.0044 2.0044 0 0 1 -2.002 2.002h-2.0141a.75.75 0 1 0 0 1.5h2.0142a3.506 3.506 0 0 0 3.502-3.502 3.4662 3.4662 0 0 0 -1.7848-3.0405z" />
      <path d="m9.92 10.0391a.75.75 0 1 0 1.061-1.0606l-2.451-2.4502a.7527.7527 0 0 0 -1.0605 0l-2.4512 2.45a.75.75 0 1 0 1.0605 1.0605l1.1712-1.17v5.4506a.75.75 0 1 0 1.5 0v-5.4504z" />
    </g>
  );
};

export default withIcon(IconCloudArrow);
